import { writeDebugMenuEntry } from "./debugMenuFunctions";
export class DebugCookieEntry {
    constructor(cookieName, menueAnzeigeName = "") {
        this.cookieName = cookieName;
        this.menueAnzeigeName = menueAnzeigeName || cookieName;
    }
    displayString() {
        const enabled = this.cookieExists();
        return writeDebugMenuEntry('VIEWERFEATURE.' + this.cookieName + '.toggle();', this.menueAnzeigeName + " is <span style='color:" + (enabled ? "green" : "red") + "'>" + (enabled ? "enabled" : "disabled") + "</span>", this.cookieName);
    }
    cookieExists() {
        return document.cookie.split(";").some(i => i.trim().indexOf(this.cookieName) === 0);
    }
    toggle() {
        if (this.cookieExists()) {
            document.cookie = this.cookieName + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
        }
        else {
            document.cookie = this.cookieName + "=1; expires=Thu, 01 Jan 2050 00:00:01 GMT; path=/";
        }
        $("#" + this.cookieName).off().replaceWith(this.displayString());
    }
}
//# sourceMappingURL=debugCookieEntry.js.map